import gql from 'graphql-tag'

const updateAzione = gql`
  mutation updateAzione($azione: UpdateAzione!, $id: Int!) {
    updateAzione(azione: $azione, id: $id) {
      id
      utenteId
      utente {
        id
        nome
      }
      clienteId
      cliente {
        id
        nome
      }
      offertaId
      offerta {
        id
        nome
      }
      campagnaId
      campagna {
        id
        nome
      }
      tipoAzioneId
      tipoAzione {
        id
        tipo
      }
      appuntamentoAgenteId
      appuntamentoAgente {
        id
        nome
      }
      dataOra
      descrizione
      appuntamentoDaDataOra
      appuntamentoADataOra
      appuntamentoLuogo
      appuntamentoStato
      appuntamentoOrigine
      promemoriaUtenteId
        promemoriaUtente {
          id
          nome
          ruolo
        }
        promemoriaDataOra
        promemoriaDismesso
      votoAgente
      flagSondaggioInviato
      nonRisposto
    }
  }
`

export default updateAzione


// WEBPACK FOOTER //
// ./src/graphql/mutations/updateAzione.js